import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: 'Aclonica, sans-serif',
    body: 'Aclonica, sans-serif',
  },
  colors: {
    gold: {
      50: '#FFF7E6',
      100: '#FFE5B2',
      200: '#FFD380',
      300: '#FFC14D',
      400: '#FFAF1A',
      500: '#E69500',
      600: '#B37400',
      700: '#805300',
      800: '#4D3200',
      900: '#1A1100',
    },
    brand: {
      primary: "#8247E5",    // Purple
      secondary: "#00E676",  // Green
      accent1: "#FF3366",    // Pink
      accent2: "#00B894",    // Teal
      accent3: "#FFC107",    // Yellow
      accent4: "#FF6B6B",    // Coral
      accent5: "#4A90E2",    // Blue
    },
  },
  components: {
    Button: {
      baseStyle: {
        _focus: {
          boxShadow: '0 0 0 3px rgba(100, 100, 100, 0.6)',
        },
      },
    },
    Link: {
      baseStyle: {
        _focus: {
          boxShadow: '0 0 0 3px rgba(100, 100, 100, 0.6)',
          outline: 'none',
        },
      },
    },
    Tabs: {
      baseStyle: {
        tab: {
          border: 'none',
          boxShadow: 'none',
          outline: 'none',
          _focus: {
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
          },
          _active: {
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
          }
        }
      },
      variants: {
        'soft-rounded': {
          tab: {
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
            _hover: {
              border: 'none',
              borderColor: 'transparent',
              boxShadow: 'none'
            },
            _focus: {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            },
            _active: {
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
            }
          },
        },
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: '#0D1019',
        backgroundImage: 'radial-gradient(circle at center, #1a1a1a 0%, #000000 100%)',
        color: 'whiteAlpha.900',
        minHeight: '100vh',
      },
      'a:focus, button:focus': {
        outline: '2px solid rgba(100, 100, 100, 0.6)',
        outlineOffset: '2px',
      },
      ':focus-visible': {
        outline: '2px solid rgba(100, 100, 100, 0.6)',
        outlineOffset: '2px',
      },
      '.chakra-tabs__tab': {
        border: 'none !important',
        borderWidth: '0 !important',
        boxShadow: 'none !important',
        outline: 'none !important',
      },
      '.chakra-tabs__tablist': {
        border: 'none !important',
        borderWidth: '0 !important',
        borderBottom: 'none !important',
        boxShadow: 'none !important',
        outline: 'none !important',
      },
      '.chakra-tabs__tab-panel': {
        border: 'none !important',
        borderWidth: '0 !important',
        boxShadow: 'none !important',
        outline: 'none !important',
      },
      '.chakra-tabs': {
        border: 'none !important',
        borderWidth: '0 !important',
        boxShadow: 'none !important',
        outline: 'none !important',
      }
    }
  },
  textStyles: {
    heading: {
      fontFamily: 'heading',
      fontWeight: 'bold',
    },
    body: {
      fontFamily: 'body',
      lineHeight: 'tall',
    },
  },
  semanticTokens: {
    colors: {
      error: 'red.500',
      success: 'green.500',
      warning: 'yellow.500',
      info: 'blue.500',
    },
  },
});

export default theme;
